import React, { useState } from "react";
import { imgUrlConverter } from '../../util'
// import PropTypes from "prop-types";
// import cn from "classnames";
// import { ReactComponent as Next } from "./assets/chevronDown.svg";
// import { ReactComponent as Prev } from "./assets/chevronUp.svg";
// import "./styles.css";

/*
 * Read the blog post here:
 * https://letsbuildui.dev/articles/building-a-vertical-carousel-component-in-react
 */

const VerticalCarousel = ({ data }) => {
  const [activeIndex, setActiveIndex] = useState(0);

  // Used to determine which items appear above the active item
  // const halfwayIndex = Math.ceil(data.length / 2);

  // Usd to determine the height/spacing of each item
  // const itemHeight = 52;

  // Used to determine at what point an item is moved from the top to the bottom
  // const shuffleThreshold = halfwayIndex * itemHeight;

  // Used to determine which items should be visible. this prevents the "ghosting" animation
  // const visibleStyleThreshold = shuffleThreshold / 2;

  // const determinePlacement = (itemIndex) => {
  //   // If these match, the item is active
  //   if (activeIndex === itemIndex) return 0;

  //   if (itemIndex >= halfwayIndex) {
  //     if (activeIndex > itemIndex - halfwayIndex) {
  //       return (itemIndex - activeIndex) * itemHeight;
  //     } else {
  //       return -(data.length + activeIndex - itemIndex) * itemHeight;
  //     }
  //   }

  //   if (itemIndex > activeIndex) {
  //     return (itemIndex - activeIndex) * itemHeight;
  //   }

  //   if (itemIndex < activeIndex) {
  //     if ((activeIndex - itemIndex) * itemHeight >= shuffleThreshold) {
  //       return (data.length - (activeIndex - itemIndex)) * itemHeight;
  //     }
  //     return -(activeIndex - itemIndex) * itemHeight;
  //   }
  // };

  const handleClick = (direction) => {
    setActiveIndex((prevIndex) => {
      if (direction === "next") {
        if (prevIndex + 1 > data.length - 1) {
          return 0;
        }
        return prevIndex + 1;
      }

      if (prevIndex - 1 < 0) {
        return data.length - 1;
      }

      return prevIndex - 1;
    });
  };

  return (
    <div className="vertical-carousel">
      <section className="outer-container">
        <div className="carousel-wrapper">
          {data?.length > 4 && <button
            type="button" aria-label="button"
            className="carousel-button prev"
            onClick={() => handleClick("prev")}
          >
            {/* <Prev /> */}
            <i className="fas fa-arrow-up"></i>
          </button>}

          <div className="carousel">
            <div className="slides">
              <div className="carousel-inner">
                {data?.length > 0 && data.map((item, i) => (
                  <div
                    // type="button"
                    onClick={() => setActiveIndex(i)}
                    // className={cn("carousel-item", {
                    //   active: i,
                    //   visible:
                    //     Math.abs(determinePlacement(i)) <= visibleStyleThreshold
                    // })}
                    key={i}
                    // style={{
                    //   transform: `translateY(${determinePlacement(i)}px)`
                    // }}
                  >
                    <img height={100} width={100} src={imgUrlConverter(item.altImageUrl)} alt={item.altImageDisplayName} />
                    
                  </div>
                ))}
              </div>
            </div>
          </div>

          {data?.length > 4 && <button
            type="button" aria-label="button"
            className="carousel-button next"
            onClick={() => handleClick("next")}
          >
            {/* <Next /> */}
            <i className="fas fa-arrow-down"></i>
          </button>}
        </div>
        <div className="content">
          <img
            src={data?.length > 0 && data[activeIndex].altImageUrl && imgUrlConverter(data[activeIndex].altImageUrl)}
            alt={data?.length > 0 ? data[activeIndex].altImageDisplayName : ""}
          />
        </div>
      </section>
    </div>
  );
};

export default VerticalCarousel;
